var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user != null)?_c('div',[_c('img',{staticClass:"center",attrs:{"src":_vm.logoApp}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }